var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"viewportImg",staticClass:"annotation-viewport-img-box",style:(`background-image:url(${_vm.viewportImg})`),on:{"mousewheel":_vm.closeViewportImg}},[_c('div',{staticClass:"close-icon-box",on:{"click":_vm.closeViewportImg}},[_c('i',{staticClass:"el-icon-close"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }